import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// Strip HTML tags and bare URLs from rich-text content to build a plain-text preview.
export function stripHtmlPreview(text, length) {
  if (!text) return '';
  const clean = text.replace(/<[^>]*>/g, '').replace(/https?:\/\/\S+/g, '');
  return length ? clean.substring(0, length) : clean;
}

// Czech plural forms: 1 -> one, 2–4 -> few, 0 and 5+ -> many.
export function plural(n, one, few, many) {
  if (n === 1) return one;
  if (n >= 2 && n <= 4) return few;
  return many;
}
